import React, { useState, useEffect } from "react";
import { useInView } from "react-intersection-observer";
import sanityClient from "../client.js";
import imageUrlBuilder from "@sanity/image-url";
import { PortableText } from "@portabletext/react";
import Vimeo from "@u-wave/react-vimeo";

const builder = imageUrlBuilder(sanityClient);

function urlFor(source) {
  return builder.image(source);
}

const Googlemaps = () => {
  const [allPostsData, setAllPosts] = useState(null);

  const components = {
    types: {
      image: (props) => (
        <figure>
          <img src={urlFor(props.value.asset).width(200).url()} />
        </figure>
      ),
      h1: ({ props }) => <h1 className="text-2xl">{props}</h1>,
    },
    block: {
      // Ex. 1: customizing common block types
      h1: ({ children }) => <h1 className="text-2xl">{children}</h1>,
      h2: ({ children }) => (
        <h2 className="text-2xl md:text-3xl py-4 leading-snug text-gray-800 dark:text-gray-200 md:text-4xl">
          {children}
        </h2>
      ),
      blockquote: ({ children }) => (
        <blockquote className="border-l-purple-500">{children}</blockquote>
      ),

      // Ex. 2: rendering custom styles
      customHeading: ({ children }) => (
        <h2 className="text-3xl leading-snug text-gray-800 dark:text-gray-200 md:text-4xl">
          {children}
        </h2>
      ),
    },
  };

  useEffect(() => {
    sanityClient
      .fetch(
        `*[_type == "locatie"]{
        title,
        body,
        slug,
        text,
        image,
        mainImage{
          asset->{
          _id,
          url
        }
      }
    }`,
      )
      .then((data) => setAllPosts(data))
      .catch(console.error);
  }, []);

  const { ref, inView } = useInView({
    triggerOnce: true,
  });
  return (
    <section className="containergooglemaps">
      <div className="container p-4 mx-auto space-y-16 sm:p-10">
        <div className="space-y-4">
          <h3 className="text-2xl font-bold leading-none sm:text-5xl">
            Zo bereik je onze praktijk.
          </h3>
          <p className="max-w-2xl dark:text-gray-600"></p>
        </div>{" "}
        {allPostsData?.map((locatie) => (
          <article
            key={locatie._id || locatie.slug?.current || locatie.title}
            className="container grid grid-cols-1 gap-8  mx-auto lg:grid-cols-2"
          >
            {" "}
            {/* Kolom 1 */}{" "}
            <div ref={ref} className={`box w-full ${inView ? "actives" : ""}`}>
              {" "}
              {locatie.text && (
                <h2 className="text-2xl md:text-3xl py-4 leading-snug text-gray-800 dark:text-gray-200 md:text-4xl">
                  {" "}
                  Logopeda praktijk Bink 36 : Magazijn 3de verdieping, Kamer 46.
                  Bekijk de video hoe je er makkelijk kunt komen.
                </h2>
              )}
              <div className="embed-container mt-6">
                <Vimeo video="766144233" width="640" height="564" />
              </div>
            </div>
            {/* Kolom 2 */}
            <div ref={ref} className={`box w-full ${inView ? "actives" : ""}`}>
              <h2 className="text-2xl md:text-3xl py-4 leading-snug text-gray-800 dark:text-gray-200 md:text-4xl">
                {" "}
                Logopeda praktijk Comfort zone : 4de verdieping, Kamer A4.11.
                Bekijk de video hoe je er makkelijk kunt komen.
              </h2>

              {locatie.body && (
                <p className="mt-4 text-lg text-gray-500 dark:text-gray-300">
                  {locatie.body}
                </p>
              )}

              <div className="embed-container mt-6">
                <Vimeo video="1205423165" width="640" height="564" />
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};
export { Googlemaps };
